import { postApi } from "./api_instance";

export const counterofferAcceptPostApi = async (data, dispatch) => {
  try {
    return await postApi({
      apiUrl: "/projects/api/myBids/accept-Countered-Offer-OnBid",
      sendToken: true,
      dispatch,
      data,
    });
  } catch (error) {
    throw error;
  }
};
